/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Notes API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * Number of results for each page
     * @type {number}
     * @memberof Pagination
     */
    size: number;
    /**
     * Current page number
     * @type {number}
     * @memberof Pagination
     */
    page: number;
    /**
     * Number of total pages available
     * @type {number}
     * @memberof Pagination
     */
    totalPages: number;
}

export function PaginationFromJSON(json: any): Pagination {
    return PaginationFromJSONTyped(json, false);
}

export function PaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'size': json['size'],
        'page': json['page'],
        'totalPages': json['totalPages'],
    };
}

export function PaginationToJSON(value?: Pagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'size': value.size,
        'page': value.page,
        'totalPages': value.totalPages,
    };
}


